<script setup>
import { computed, inject, ref } from 'vue'
import PersonCard from '@/__v1.5__/components/cards/PersonCard.vue'
import ScrollingContainer from '@/__core__/containers/scrolling-container/ScrollingContainer.vue'
import { loc } from '@/__core__/localization/localization'

defineProps({
  data: Object,
})

const playersOverviewContainerRef = ref(null)
const playersContainerRef = ref(null)
const langId = inject('langId', '')

const playersOverviewContainerHeight = computed(() => playersOverviewContainerRef?.value?.clientHeight || 0)

const translateRole = positionAbr => {
  const map = {
    "defender": "player_details_defense",
    "midfielder": "player_details_midfield",
    "forward": "player_details_forward",
    "goalkeeper": "player_details_goalkeeper"
  }

  return map[positionAbr] ? loc(map[positionAbr], langId) : positionAbr || '-'
}
</script>

<template>
  <div class="szw-flex szw-h-full szw-relative" ref="playersOverviewContainerRef">
    <scrolling-container
      :widget-container-height="playersOverviewContainerHeight"
      :container-ref="playersContainerRef"
      :container-id="data?.teamName"
      :button-offset="0"
      :disableAnimationWhenReseting="true"
    >
      <div class="szw-scrollable-container" ref="playersContainerRef">
        <person-card :card-type="'manager'" :logo="data?.teamLogo" :title="data?.manager?.name" :team-name="data?.teamName" :subtitle="loc('sm_manager', langId)"/>
        <person-card
          v-for="player in data?.playerDataList"
          :card-type="'player'"
          :logo="data?.teamLogo"
          :team-name="data?.teamName"
          :key="player.id"
          :title="player.name"
          :subtitle="translateRole(player.position)"
          :jersey="player.jerseyNumber"
          :detail="player.missingReason"
        />
      </div>
    </scrolling-container>
  </div>
</template>
